<template>
  <div class="card-demo">
    <div class="demo-container">
      <div class="card-wrapper">
        <Card>
          <h1>Card</h1>
        </Card>
      </div>

      <Separator class="separator" />

      <div class="separator-examples">
        <div class="horizontal-example">
          <Separator length="200px" />
        </div>

        <div class="vertical-example">
          <Separator orientation="vertical" length="100px" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "@/components/Card.vue";
import Separator from "@/components/Separator.vue";

export default {
  name: "CardDemo",
  components: {
    Card,
    Separator,
  },
};
</script>

<style scoped>
.card-demo {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: #111;
}

.demo-container {
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  padding: 0 1rem;
}

.card-wrapper {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}

.separator {
  width: 100%;
}

.separator-examples {
  display: flex;
  gap: 2rem;
  align-items: center;
  flex-wrap: wrap;
}

.horizontal-example,
.vertical-example {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(26, 26, 26, 0.8);
  border-radius: 12px;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

h1 {
  font-size: clamp(2rem, 5vw, 3rem);
  margin: 0;
  color: #fff;
}

@media (max-width: 768px) {
  .card-demo {
    padding: 1rem;
  }

  .demo-container {
    gap: 2rem;
  }

  .separator-examples {
    justify-content: center;
  }
}
</style>
